module.exports = __webpack_public_path__ + "static/media/about-section.380d3a2b.jpg";